// @ts-ignore - react-big-calendar types
import { Calendar } from "react-big-calendar";
// @ts-ignore - dragAndDrop addon ships its own runtime types
import withDragAndDrop from "react-big-calendar/lib/addons/dragAndDrop";
import "react-big-calendar/lib/addons/dragAndDrop/styles.css";

import { CalendarEventType } from "../../../../../types/calendar";

/**
 * `Calendar` wrapped once with the official react-big-calendar drag-and-drop
 * addon so both DayView and WeekView pick up the same drop/resize behavior.
 *
 * Touch is handled by RBC itself: `Selection._addLongPressListener`
 * (node_modules/react-big-calendar/lib/Selection.js) waits ~250ms before
 * arming the drag and cancels on touchmove, so we don't add a custom
 * long-press gate.
 */
const DnDCalendar = withDragAndDrop(Calendar);

export default DnDCalendar;

/** Payload react-big-calendar's `withDragAndDrop` HOC passes to
 * `onEventDrop` and that CalendarView's `handleEventDrop` consumes. Kept
 * here so DayView and WeekView don't have to cross-import each other. */
export interface CalendarDropInfo {
  event: CalendarEventType;
  start: Date;
  end: Date;
  resourceId?: string;
}

/** Payload react-big-calendar's `withDragAndDrop` HOC passes to
 * `onEventResize`. Resize never reports a `resourceId`. */
export interface CalendarResizeInfo {
  event: CalendarEventType;
  start: Date;
  end: Date;
}
